import styled from 'styled-components';
import { FlexColumn } from '../layoutUtils';

const Content = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.background};
  position: relative;
  height: 100%;
  // overflow: hidden;
  margin: 2px;
  margin-left: 0px;
  @media print {
    height: unset !important;
    flex: unset !important;
    overflow: visible !important;
  }
`;

export { Content };
